export const route = (string, params) => {
  if (params && Object.keys(params).length > 0) {
    Object.keys(params).forEach(function (key, i) {
      const replaceKey = key.replace('?', '\\?')

      if (params[key] !== undefined && params[key] !== null) {
        string = string.replace(new RegExp('{' + replaceKey + '}', 'g'), params[key])
      } else if (params[key] === null) {
        string = string.replace(new RegExp('{' + replaceKey + '}', 'g'), '')
      }
    })
  }

  return string
}
